import { useEffect, useState } from "react";
import Layout from "../../../Components/Layout";
import OrderFilter from "../../../Components/OrderMgt/OrderFilter";
import useHttpHook from "../../../Hooks/HttpHook";
import { GetAllOrders } from "../../../utils/ApiConstant";
import { createObjectForPaginatedResult } from "../../../utils/Helper";
import { OrderLanguage } from "../../../utils/Languages";
import OrganizerOrderListPage from "../../../Components/OrderMgt/OrganizerOrderListPage";
import { toast } from "react-toastify";
import { showErrorToast } from "../../../utils/notify";

const RecievedOrderPage = () => {
  const [, sendRequest, error] = useHttpHook();
  const [data, setData] = useState({});
  const [orderList, setOrderList] = useState(null);

  useEffect(() => {
    getOrders();
  }, [data]);

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  const handleFilterInput = (inputData) => {
    setData(inputData);
  };

  const getOrders = async (page = 1) => {
    try {
      const orders = await sendRequest(`${GetAllOrders}?page=${page}`, {
        method: "post",
        data: data,
      });
      if (page === 1) {
        setOrderList(orders);
      } else {
        setOrderList((prevState) =>
          createObjectForPaginatedResult(orders, prevState, "paginate")
        );
      }
    } catch (fetchError) {
      console.log(fetchError);
    }
  };

  return (
    <Layout
      Heading={OrderLanguage.ReceivedOrderList.heading}
      TitleMark={true}
      TitleMarkClassName="event-orders-title-mark"
      TitleClassName="event-orders-title"
      HeadClassName="event-orders-head"
      ExtraclassName="event-orders-panel event-received-orders-panel"
      activeMenuId="received-orders"
    >
      <div className="event-orders-body">
        <OrderFilter handleFilterInput={handleFilterInput} />
        <OrganizerOrderListPage orderList={orderList} getOrders={getOrders} />
      </div>
    </Layout>
  );
};

export default RecievedOrderPage;
